import { createUseQuery } from 'api/common/createUseQuery'
import { fetchMemberRolesApi } from 'api/roles/fetchers/fetchMemberRoles'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useMemberRolesApi = createUseQuery({
  queryKey: ApiQueryKeys.MEMBER_ROLES,
  fetcher: fetchMemberRolesApi,
  selector: response => response?.data,
})
